module.exports = __webpack_public_path__ + "img/banner-img-1.34f33a41.jpg";